import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Card, Result, Typography } from "antd";
import React from "react";
import { useLoader } from "../../../Context/LoaderContext/LoaderContext";

const { Paragraph, Text } = Typography;

interface FailureResultProps {
  title: string;
  subTitle: string;
  reason?: string[];
  onClick?: () => void;
}

const FailureResult: React.FC<FailureResultProps> = ({
  title,
  subTitle,
  reason,
  onClick,
}) => {
  const { isLoading } = useLoader()
  return (
    <Card>
      <Result
        status="error"
        title={title}
        subTitle={subTitle}
        extra={
          onClick && (
            <Button type="primary" onClick={onClick} loading={isLoading}>
              Try Again
            </Button>
          )
        }
      >
        {reason && (
          <div className="desc">
            {reason.map((item, index) => (
              <Paragraph type="danger" key={index} style={{ marginRight: "8px" }}>
                <CloseCircleOutlined
                  style={{ marginRight: "8px" }}
                  className="site-result-demo-error-icon"
                />
                {item}
              </Paragraph>
            ))}
          </div>
        )}
      </Result>
    </Card>
  );
};

export default FailureResult;
